import React from 'react';
import { MetricsTrendPanel } from '@modules/monitor/resource-triage/components/MetricsTrendPanel';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import { ViewType } from '../../constants/viewTypes';
import styles from './MetricsChartSection.module.scss';

interface MetricsChartSectionProps {
  title: string;
  viewType: ViewType;
  data: React.ComponentProps<typeof MetricsTrendPanel>['data'];
  loading: boolean;
  start: Date;
  end: Date;
  onDatesChanged: (start: Date, end: Date) => void;
  csvCategory?: string; // distinguishes account-scoped CSV exports (e.g. read vs write) in the filename.
}

/**
 * Shared presentational wrapper for the Utilization trend charts (Flow Activity,
 * Read/Write Operations). Owns the admin-aware title and the MetricsTrendPanel
 * rendering so each section only has to provide its own data source.
 */
export const MetricsChartSection = ({
  title,
  viewType,
  data,
  loading,
  start,
  end,
  onDatesChanged,
  csvCategory,
}: MetricsChartSectionProps) => {
  const user = useCurrentUser();
  // Admins toggle between Org/Mine, so the active scope is appended to the title.
  const chartTitle = user.isAdmin ? `${title} · ${viewType}` : title;

  return (
    <MetricsTrendPanel
      data={data}
      loading={loading}
      start={start}
      end={end}
      onDatesChanged={(next) => onDatesChanged(new Date(next.start), new Date(next.end))}
      title={chartTitle}
      titleClassName={styles.title}
      csvCategory={csvCategory}
      hideDateControls
    />
  );
};
